import PrimaryButton from '@/components/Buttons/PrimaryButton';
import PageTitle from '@/components/PageTitle';
import ThemeWrapper from '@/components/ThemeWrapper';
import AppLayout from '@/layouts/AppLayout';
import { usePage } from '@inertiajs/react';
import React from 'react';

interface HerramientasCard {
    title: string;
    description: string;
    url: string;
    button_text: string;
}

interface HerramientasConfig {
    title: string;
    cards: HerramientasCard[];
}

interface PageProps {
    static_page: {
        id: number;
        name: string;
        slug: string;
        config: HerramientasConfig;
    };
}

const HerramientasContent: React.FC = () => {
    const { static_page } = usePage<{ static_page: PageProps['static_page'] }>().props;
    const config = static_page.config;

    return (
        <AppLayout>
            <PageTitle title={static_page.name} />
            <div className="mx-auto max-w-7xl space-y-8">
                <h1 className="text-4xl font-bold text-gray-900 sm:text-5xl">
                    {config.title}
                </h1>

                <div className="grid gap-6 md:grid-cols-3">
                    {config.cards.map((card, index) => (
                        <div
                            key={index}
                            className="flex flex-col rounded-xl border border-gray-200 bg-white shadow-sm transition-all duration-300 hover:shadow-md"
                        >
                            <div className="flex-1 space-y-4 p-6">
                                <h3 className="text-2xl font-bold text-gray-900">
                                    {card.title}
                                </h3>
                                <p className="text-base text-gray-700">
                                    {card.description}
                                </p>
                            </div>
                            <div className="p-6 pt-0">
                                <PrimaryButton
                                    as="link"
                                    href={card.url}
                                    size="full-width"
                                    className="uppercase tracking-wide"
                                >
                                    {card.button_text}
                                </PrimaryButton>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </AppLayout>
    );
};

const Herramientas: React.FC = () => (
    <ThemeWrapper>
        <HerramientasContent />
    </ThemeWrapper>
);

export default Herramientas;
